import { calculatePremium } from "../../premium/domain/calculatePremium";
import {
  parseCurrencyToNumber,
  recalcGuardianshipPremiumFromBasicInfo,
} from "./formHelpers";

export function calculateAgeFromDate(dateOfBirth) {
  const birthDate = new Date(dateOfBirth);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function applyRetrievalStandardPremium(updatedData, defaultCountField) {
  if (!updatedData.bondAmount) return null;
  const bondAmount = parseCurrencyToNumber(updatedData.bondAmount);
  if (!Number.isFinite(bondAmount)) return null;
  const premium = calculatePremium(bondAmount);
  return {
    ...updatedData,
    premiumAmount: premium,
    [defaultCountField]: "1",
  };
}

export function applyRetrievalGuardianshipPremium(updatedData) {
  if (!updatedData.bondAmount || !updatedData.dateOfDeath) return null;
  const premium = recalcGuardianshipPremiumFromBasicInfo({
    bondAmount: updatedData.bondAmount,
    dateOfDeath: updatedData.dateOfDeath,
    bondSubCategory: updatedData.bondSubCategory,
  });
  if (premium === null) return null;
  return {
    ...updatedData,
    premiumAmount: premium,
  };
}
